// src/modules/restaurant/pages/orders/hooks/useOrderStatus.ts
import { Order } from "src/shared/services/interfacev2";

export const useOrderStatus = (order: Order | null) => {
  const status = order?.orders[0].status?.toLowerCase() || "";
  const isCancelled = status === "cancelled";
  const isCompleted = status === "completed";
  const statusLabel = isCancelled ? "Cancelled" : isCompleted ? "Completed" : "Active";
  const statusClass = isCancelled ? "text-red-600" : isCompleted ? "text-green-600" : "text-amber-600";

  return { isCancelled, isCompleted, statusLabel, statusClass };
};
